import React from 'react';
import { NavLink } from 'react-router-dom';
import { BookOpen, CalendarDays, CheckCircle2, Home, LifeBuoy, PlusCircle, Sparkles, WifiOff } from 'lucide-react';
import { useDatos } from '../../contexts/DatosContext';
import { formatearFechaHora } from '../../utils/clase';
const ENLACES = [{
  a: '/',
  texto: 'Inicio',
  icono: Home
}, {
  a: '/nueva',
  texto: 'Nueva clase',
  icono: PlusCircle
}, {
  a: '/clases',
  texto: 'Mis clases',
  icono: CalendarDays
}, {
  a: '/biblioteca',
  texto: 'Biblioteca',
  icono: BookOpen
}, {
  a: '/personalizados',
  texto: 'Ejercicios personalizados',
  icono: Sparkles
}, {
  a: '/ayuda',
  texto: 'Ayuda y seguridad',
  icono: LifeBuoy
}];
const ENLACES_MOVIL = ENLACES.slice(0, 4);
export function Estructura({
  children
}: {
  children: React.ReactNode;
}) {
  const {
    ultimoGuardado,
    almacenamientoOk,
    notificaciones,
    descartarNotificacion
  } = useDatos();
  return <div className="min-h-screen w-full bg-lienzo" data-id="element-351" data-mp="1wnya7v8iqocu">
      <header className="no-imprimir sticky top-0 z-30 border-b border-linea bg-white" data-id="element-352" data-mp="1wlln73nwlnsx">
        <div className="mx-auto flex w-full max-w-6xl items-center justify-between gap-4 px-4 py-3" data-id="element-353" data-mp="2cehqsoasib2k">
          <div className="flex items-center gap-3" data-id="element-354" data-mp="27h9a6s5aif3f">
            <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-vino-oscuro text-sm font-extrabold text-white" aria-hidden="true" data-id="element-355" data-mp="2mcp7d6162r41">
              PP
            </span>
            <div className="leading-tight" data-id="element-356" data-mp="2vbj1mpr0z5ef">
              <p className="text-sm font-extrabold text-vino" data-id="element-357" data-mp="2qeafyf6o4j8f">Planificador Pro</p>
              <p className="text-xs text-tinta-tenue" data-id="element-358" data-mp="2qc6d80ki9q9q">Clases de telas</p>
            </div>
          </div>

          <nav aria-label="Navegación principal" className="hidden lg:block" data-id="element-359" data-mp="303tzln27gh4c">
            <ul className="flex items-center gap-1" data-id="element-360" data-mp="305wzqzx2nqms">
              {ENLACES.map(e => <li key={e.a} data-id="element-361" data-mp="3e3uzp0anbkir">
                  <NavLink to={e.a} end={e.a === '/'} className={({
                isActive
              }) => `flex min-h-[44px] items-center gap-2 rounded-xl px-3 text-sm font-semibold transition-colors ${isActive ? 'bg-vino/5 text-vino' : 'text-tinta-sec hover:bg-vino/5 hover:text-vino'}`} data-id="element-362" data-mp="3a1zxzuosz54g">
                    <e.icono className="h-4 w-4" aria-hidden="true" data-id="element-363" data-mp="3vvx8ztpdoogz" />
                    {e.texto}
                  </NavLink>
                </li>)}
            </ul>
          </nav>

          <div className="hidden shrink-0 items-center gap-2 text-xs text-tinta-tenue sm:flex" data-id="element-364" data-mp="8r7rg1rer08t">
            {almacenamientoOk ? <>
                <CheckCircle2 className="h-4 w-4 text-verde" aria-hidden="true" data-id="element-365" data-mp="imj2oa3lxpbt" />
                <span data-id="element-366" data-mp="2fgmaqyfuwja0">
                  Guardado en este dispositivo
                  {ultimoGuardado ? ` · ${formatearFechaHora(ultimoGuardado)}` : ''}
                </span>
              </> : <>
                <WifiOff className="h-4 w-4 text-alerta" aria-hidden="true" data-id="element-367" data-mp="11ldxt61magyq" />
                <span className="font-semibold text-alerta" data-id="element-368" data-mp="ws1l9ua7q0mc">Almacenamiento no disponible</span>
              </>}
          </div>
        </div>

        <div className="border-t border-linea px-4 py-2 lg:hidden" data-id="element-369" data-mp="sp4vnjm9948w">
          <nav aria-label="Secciones adicionales" data-id="element-370" data-mp="ntzesz7pmfro">
            <ul className="flex gap-2 overflow-x-auto" data-id="element-371" data-mp="1kif7v5a1379j">
              {ENLACES.slice(4).map(e => <li key={e.a} data-id="element-372" data-mp="1ggk65zo6qrv8">
                  <NavLink to={e.a} className={({
                isActive
              }) => `flex min-h-[44px] items-center gap-2 whitespace-nowrap rounded-xl border px-3 text-sm font-semibold ${isActive ? 'border-vino bg-vino/5 text-vino' : 'border-linea bg-white text-tinta-sec'}`} data-id="element-373" data-mp="1giepxanq0dxq">
                    <e.icono className="h-4 w-4" aria-hidden="true" data-id="element-374" data-mp="1j0ot6so1lg5o" />
                    {e.texto}
                  </NavLink>
                </li>)}
              <li className="flex min-h-[44px] items-center gap-2 whitespace-nowrap rounded-xl border border-linea bg-white px-3 text-xs text-tinta-tenue" data-id="element-375" data-mp="1nt9mlt31dr8o">
                {almacenamientoOk ? <>
                    <CheckCircle2 className="h-4 w-4 text-verde" aria-hidden="true" data-id="element-376" data-mp="22oftei9yhu32" />
                    Guardado en este dispositivo
                  </> : <>
                    <WifiOff className="h-4 w-4 text-alerta" aria-hidden="true" data-id="element-377" data-mp="1sq8f6771xq4r" />
                    Almacenamiento no disponible
                  </>}
              </li>
            </ul>
          </nav>
        </div>
      </header>

      <main className="mx-auto w-full max-w-6xl px-4 pb-28 pt-5 lg:pb-12" data-id="element-378" data-mp="habexmtrjjs8">{children}</main>

      <nav aria-label="Navegación inferior" className="no-imprimir fixed inset-x-0 bottom-0 z-30 border-t border-linea bg-white lg:hidden" data-id="element-379" data-mp="mb7ghtqn6tuh">
        <ul className="mx-auto flex max-w-6xl" data-id="element-380" data-mp="9rk817yiivjj">
          {ENLACES_MOVIL.map(e => <li key={e.a} className="flex-1" data-id="element-381" data-mp="9twspsvnnk0a">
              <NavLink to={e.a} end={e.a === '/'} className={({
            isActive
          }) => `flex min-h-[56px] flex-col items-center justify-center gap-1 px-1 py-2 text-[11px] font-semibold ${isActive ? 'text-vino' : 'text-tinta-tenue'}`} data-id="element-382" data-mp="nqa88wgmpbc4">
                <e.icono className="h-5 w-5" aria-hidden="true" data-id="element-383" data-mp="4s7e63984o7g" />
                <span className="text-center leading-tight" data-id="element-384" data-mp="4uk3x2l842v2">{e.texto}</span>
              </NavLink>
            </li>)}
        </ul>
      </nav>

      <div aria-live="polite" className="no-imprimir pointer-events-none fixed bottom-20 left-1/2 z-50 flex w-[calc(100%-2rem)] max-w-sm -translate-x-1/2 flex-col gap-2 lg:bottom-6" data-id="element-385" data-mp="38gskvkybccat">
        {notificaciones.map(n => <button key={n.id} type="button" onClick={() => descartarNotificacion(n.id)} className={`pointer-events-auto rounded-xl border px-4 py-3 text-left text-sm font-semibold shadow-lg ${n.tipo === 'error' ? 'border-alerta/40 bg-white text-alerta' : 'border-verde/30 bg-white text-tinta'}`} data-id="element-386" data-mp="17d8i1jaheylg">
            {n.texto}
          </button>)}
      </div>
    </div>;
}